// tracking_scripts/tag_manager/logging.ts

/**
 * Logs a message to the console if GTM logging is enabled via
 * `window.serverData.GTMLoggingEnabled`. Used for debugging purposes.
 *
 * @param {any} message - The message or object to log to the console.
 *
 * @example
 * // Logs a message if logging is enabled
 * GTM_logEvent('GTM initialised');
 */
export function GTM_logEvent(message: any): void {
	if (window.serverData.GTMLoggingEnabled) {
		console.log(message);
	}
}
